import {SUPPORT_EMAIL, SUPPORT_PHONE} from 'constants/appConstants'

export type ActionType =
  | 'FORGOT_PASSWORD'
  | 'RESET_PASSWORD'
  | 'LOG_IN'
  | 'SIGN_UP'
  | 'PLACE_ORDER'
  | 'UPLOAD_DOCUMENT'

const ERROR_MESSAGE_END = `If the problem persists, please contact Customer Support at ${SUPPORT_EMAIL} or ${SUPPORT_PHONE}.`

export const ACTION_ERROR_MESSAGE_END = `failed. ${ERROR_MESSAGE_END}`

export const ACTION_LIMIT_EXCEEDED_ERROR_MESSAGE_END = `attempts reached. Wait 1 minute before trying again.`

export const ACTION_ERROR_MESSAGE_PREFIX_BY_TYPE: Record<ActionType, string> = {
  FORGOT_PASSWORD: 'Forgot password',
  RESET_PASSWORD: 'Reset password',
  LOG_IN: 'Log in',
  SIGN_UP: 'Sign up',
  PLACE_ORDER: 'Placing order',
  UPLOAD_DOCUMENT: 'Uploading document'
}

export const ACTION_LOG_IN_FAILURE_MESSAGE =
  'Log in failed. Check your email and password and try again.'

export const SESSION_EXPIRED_MESSAGE = 'Your session has expired. Log in to continue.'

export const ADDRESS_SEARCH_ERROR =
  'Unable to load the provided address. Check the address and try again.'

export const GET_PRODUCTS_ERROR = `Failed to retrieve products. Please refresh and try ordering again. ${ERROR_MESSAGE_END}`
